export default function(current_user, size) {
  if (current_user.avatar_path)
    return current_user.avatar_path
  return `https://www.gravatar.com/avatar/${current_user.gravatar_hash}?s=${size}&d=identicon&r=PG`
}
